import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Handler para erros de chunk/módulo dinâmico após deploy
// Quando há um novo deploy, os hashes dos chunks mudam e usuários com versão antiga
// tentam carregar arquivos que não existem mais
const triggerReloadIfNeeded = () => {
  // Evita loop infinito de reload
  const lastReload = sessionStorage.getItem('chunk_error_reload')
  const now = Date.now()

  if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
    sessionStorage.setItem('chunk_error_reload', now.toString())
    console.warn('[BravaForte] Nova versão detectada, recarregando página...')
    window.location.reload()
  }
}

const handleChunkLoadError = (error: Error | string) => {
  const errorMessage = typeof error === 'string' ? error : error?.message || ''

  // Detecta erros de chunk/módulo dinâmico
  const isChunkError =
    errorMessage.includes('Failed to fetch dynamically imported module') ||
    errorMessage.includes('Loading chunk') ||
    errorMessage.includes('Loading CSS chunk') ||
    errorMessage.includes('Unable to preload CSS') ||
    errorMessage.includes('MIME type') ||
    (errorMessage.includes('text/html') && errorMessage.includes('module'))

  if (isChunkError) {
    triggerReloadIfNeeded()
  }
}

// Listener para erros de promise não tratadas (import dinâmico)
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason) {
    handleChunkLoadError(event.reason)
  }
})

// Listener para erros gerais de script (inclui erros de módulo)
window.addEventListener('error', (event) => {
  // Verifica se é erro de carregamento de script/módulo
  const target = event.target as HTMLElement | null
  if (target?.tagName === 'SCRIPT' || target?.tagName === 'LINK') {
    console.warn('[BravaForte] Erro ao carregar recurso:', (target as HTMLScriptElement).src || (target as HTMLLinkElement).href)
    triggerReloadIfNeeded()
    return
  }

  if (event.message) {
    handleChunkLoadError(event.message)
  }
}, true) // useCapture=true para capturar erros de módulo

createRoot(document.getElementById("root")!).render(<App />)
